import { render, staticRenderFns } from "./PcVideo.vue?vue&type=template&id=210be990&scoped=true"
import script from "./PcVideo.vue?vue&type=script&lang=js"
export * from "./PcVideo.vue?vue&type=script&lang=js"
import style0 from "./PcVideo.vue?vue&type=style&index=0&id=210be990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210be990",
  null
  
)

export default component.exports